const benefits = {
  // HeroSection
  'benefits.hero.homeLink': 'ホーム',
  'benefits.hero.pricingLink': '料金・特典',
  'benefits.hero.currentPage': '受講特典',
  'benefits.hero.imgAlt': '白手袋・懐中時計・教科書など受講特典の品々を格調高く配置した静物',

  // breadcrumb
  'benefits.breadcrumb.home': 'ホーム',
  'benefits.breadcrumb.pricing': '料金・特典',
  'benefits.breadcrumb.current': '受講特典',

  // CourseBenefits
  'benefits.course.label': 'COURSE BENEFITS',
  'benefits.course.title': 'コース別特典',
  'benefits.course.titleEn': 'Benefits by Course',
  'benefits.course.lead': '受講特典は、記念品ではありません。学んだその日から実務で使える、本物の道具と装備をお渡しします。コースが上位になるほど、より豊かな装備が加わり、プロフェッショナルとしての備えが整います。少人数制で学ぶ日本の執事学校として、執事養成の現場でそのまま使える装備を受講特典にお届けします。',
  'benefits.course.inheritedBadge': '下位コースに含む',
  'benefits.course.courseLink': 'の詳細を見る',

  // CommonBenefits
  'benefits.common.label': 'COMMON BENEFITS',
  'benefits.common.title': '全コース共通の特典',
  'benefits.common.titleEn': 'COMMON BENEFITS',
  'benefits.common.certNote': '※認定資格は当協会独自の民間資格です。修了実技試験の合格が授与の条件となります。',
  'benefits.common.badgeImgAlt': '認定ピンバッジのクローズアップ',
  'benefits.common.badgeCaption': '認定ピンバッジ（試験合格者に授与）',

  // WhiteGlovesSection
  'benefits.gloves.label': 'WHITE GLOVES',
  'benefits.gloves.title': '白手袋について',
  'benefits.gloves.titleEn': 'WHITE GLOVES',
  'benefits.gloves.imgAlt': '白手袋を着用してカトラリーを丁寧に扱う執事の手元',
  'benefits.gloves.pt1Label': '全コース共通',
  'benefits.gloves.pt1Desc': '初日から支給',
  'benefits.gloves.pt2Label': '実習着',
  'benefits.gloves.pt2Desc': 'サービス実習で常時着用',
  'benefits.gloves.pt3Label': '象徴',
  'benefits.gloves.pt3Desc': '清潔さ・品格・専門性',

  // NotesSection
  'benefits.notes.label': 'NOTES',
  'benefits.notes.title': 'ご注意事項',
  'benefits.notes.titleEn': 'Please Note',

  // CTASection
  'benefits.cta.label': 'NEXT STEP',
  'benefits.cta.title': '特典の詳細は資料でご確認ください',
  'benefits.cta.lead': '各コースの特典内容や、ご自身に最適なコースについて、まずは無料の資料請求からどうぞ。個別相談では、日本の執事学校・日本執事アカデミーの特典品の実物をご覧いただけます。',
  'benefits.cta.onlineNote': '※ご相談はオンラインでも承ります',
  'benefits.cta.certBtn': '修了証・認定資格を見る',
  'benefits.cta.coursesBtn': 'コースを見る',
  'benefits.cta.brochureBtn': '資料請求はこちら（無料）',
  'benefits.cta.consultBtn': '個別相談を予約する',

  // FAQSection
  'benefits.faq.label': 'FAQ',
  'benefits.faq.title': 'よくあるご質問',
  'benefits.faq.titleEn': 'Frequently Asked Questions',
  'benefits.faq.contactNote': 'その他のご質問は',
  'benefits.faq.contactLink': 'お問い合わせ',
  'benefits.faq.contactSuffix': 'よりお寄せください',

  // RelatedPages
  'benefits.related.label': 'LEARN MORE',
  'benefits.related.title': '関連ページ',
  'benefits.related.titleEn': 'Explore Further',
  'benefits.related.arrowLabel': '詳しく見る',

  // footer
  'benefits.footer.lastUpdated': '最終更新: 2026年6月13日',
  'benefits.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default benefits;
